import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    title: {
      color: theme.chart.projection.inverted.text,
      flex: 1,
    },
    text: {
      color: theme.chart.projection.inverted.text,
    },
    info: {
      marginTop: spacing.xxs,
      marginRight: spacing.xxs,
    },
    infoSection: {
      userSelect: "none",
    },
  };

  return styles;
};
